export default {"src":"/_next/static/media/Download-white.3a840d27.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};